import React , { useState, useRef } from 'react';
import {AnimatePresence, motion, useScroll , useMotionValue, useTransform} from "framer-motion/dist/framer-motion";


const logo = {
  hidden: {
    opacity: 1,
    pathLength: 0
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
          pathLength: { duration: 5, ease: "easeInOut", delay:3.5  },
      }
  }
};


const Fondo5 = ({possx , possy  }) => {
  
  const boxRef = useRef();
  const { scrollYProgress } = useScroll({
    target:  boxRef,
  });

  return (

  <div className="pup3" id="fondo1" ref={boxRef}  >


    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1350 1137.9"
      style={{
        x: possx ,
        y: possy,
      }}
    >
      <motion.path
        className="fondow"
        d="M5,1L39.9,712.5M7.4,1.3l57.2,710.1M9.8,2L89.3,709.9M12.2,3L113.9,708.1M14.6,4.4l123.8,701.6M17.1,6.1L162.9,703.5M19.7,8.2L187.3,700.6M22.3,10.6L211.6,697.4M25,13.4L235.8,693.9M27.8,16.5l232,673.6M30.7,20l253.1,665.9M33.7,23.8L307.6,681.4M36.9,27.9L331.3,676.6M40.1,32.3L354.8,671.5M43.6,37.1L378.1,666.1M47.1,42.2L401.3,660.4M50.9,47.6L424.2,654.4M54.8,53.4L447,648M58.9,59.4L469.6,641.5M63.2,65.7L492,634.6M67.6,72.3l446.5,555.2M72.3,79.2l463.7,540.9M77.3,86.4l480.4,526M82.4,93.8l496.7,510.7M87.8,101.5l512.5,494.8M93.4,109.5l527.8,478.5M99.3,117.7l542.6,461.7M105.5,126.2l551.6,440.2M111.9,134.9l573.7,430.9M118.6,143.8l583.6,408.5M125.5,152.9l596.2,390M132.8,162.2l608.1,371.1M140.4,171.7l619.4,351.8M148.2,181.5l630.2,332.1M156.4,191.3L796.7,503.6M164.9,201.4L814.7,493.3M173.7,211.6L832.3,483M182.8,222l666.9,250.5M192.2,232.5l674.5,229.5M202,243.1l681.3,208.2M212.1,253.9l687.5,186.6M222.6,264.7l693,165M233.4,275.6l697.8,143.2M244.5,286.7l702,121.1m-690.5-110l705.5,99m-693.7-87.8l708.3,76.8m-696.1-65.6l710.3,54.5m-697.8-43.3l711.7,32.2m-698.8-20.9l712.4,9.9m-699.1,1.4l712.3-12.5m-698.7,23.8l711.5-34.9m-697.6,46.3l710.1-57.3m-695.8,68.6l708-79.6m-693.3,90.8l705.1-101.7m-690.1,113l701.6-123.8M405.6,421.6l697.3-145.7M421.3,432.8l692.4-167.6M437.3,443.8l686.8-189.2M453.8,454.8l680.5-210.8M470.5,465.7l673.6-232M487.6,476.5l665.9-253.1M505,487.1L1162.7,213.3M522.8,497.7L1171.5,203.3M540.9,508.1L1180,193.5m-620.7,324.9L1188.3,183.8m-610.3,344.7L1196.2,174.3m-599.1,364.1L1203.8,165m-587.4,383.2L1211.1,155.9m-575,401.9L1218.2,147.1m-562.2,420.1L1224.9,138.4m-539.3,427.4L1231.4,129.9m-528.6,451.8L1237.7,121.7m-520.1,472.4L1243.6,113.7m-504.9,489L1249.4,105.9m-489.3,505.1L1254.9,98.4m-473.2,520.6L1260.1,91.2m-456.6,535.6L1265.2,84.2m-439.6,550.1L1270,77.5m-422.1,564.1L1274.6,71.1m-404.1,577.5L1279,65m-385.8,590.3L1283.2,59.1m-367,602.6L1287.3,53.6m-348,614.3L1291.1,48.4m-328.4,625.3L1294.9,43.5m-308.7,635.7L1298.4,38.9m-288.5,645.5L1301.8,34.6m-268,654.7L1305.1,30.6m-247.3,663.3L1308.3,27m-226.4,671.1L1311.4,23.7m-205.2,678.3L1314.3,20.7m-183.8,684.9L1317.2,18.1m-162.2,690.7L1320,15.8m-140.4,695.9L1322.8,13.8m-118.5,700.4L1325.4,12.2m-96.4,704.2L1328.1,11m-74.3,707.3L1330.6,10m-51.9,709.8L1333.2,9.5m-29.6,711.4L1335.8,9.3m-7.3,712.4l9.8-712.3m15.1,712.8l-12.5-712.3"
        variants={logo}
        initial="hidden"
        animate="visible"
      />
     
        <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1352.2" y1="614.2" x2="1330.4" y2="611.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1352.6" y1="629.8" x2="1306.3" y2="624.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1352.9" y1="644.1" x2="1282.8" y2="638.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1353.2" y1="657.3" x2="1259.9" y2="652"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1353.4" y1="669.5" x2="1237.4" y2="665.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1353.7" y1="680.5" x2="1215.6" y2="679.1"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1348.9" y1="690.5" x2="1194.2" y2="692.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1355.6" y1="690.4" x2="1348.9" y2="690.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.1" y1="699.4" x2="1173.4" y2="706.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.2" y1="707.4" x2="1153.2" y2="719.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.4" y1="714.4" x2="1133.4" y2="733.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.5" y1="720.4" x2="1114.3" y2="746.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.6" y1="725.4" x2="1095.6" y2="760"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.7" y1="729.5" x2="1077.5" y2="773.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.8" y1="732.6" x2="1060" y2="786.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.8" y1="734.8" x2="1042.9" y2="799.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.8" y1="736" x2="1026.4" y2="812.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.9" y1="736.2" x2="1010.4" y2="825.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.8" y1="735.4" x2="994.9" y2="837.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.8" y1="733.7" x2="979.9" y2="850.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.7" y1="730.9" x2="965.5" y2="862.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.7" y1="727" x2="951.5" y2="874.6"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.5" y1="722" x2="938" y2="886.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.4" y1="716" x2="925" y2="898.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.3" y1="708.7" x2="912.5" y2="909.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1354.1" y1="700.2" x2="900.4" y2="921"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1353.9" y1="690.4" x2="888.8" y2="932"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1353.6" y1="679.2" x2="877.6" y2="942.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1353.4" y1="666.5" x2="866.9" y2="953.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1353" y1="652.3" x2="856.6" y2="963.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1352.7" y1="636.5" x2="846.7" y2="973.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1352.3" y1="618.8" x2="837.2" y2="983.1"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1351.9" y1="599.1" x2="828.1" y2="992.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1351.4" y1="577.3" x2="819.4" y2="1001.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1350.9" y1="553.2" x2="811" y2="1010.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1350.3" y1="526.4" x2="803" y2="1018.6"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1349.7" y1="496.7" x2="795.4" y2="1026.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1131.9" y1="705" x2="788" y2="1034.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1106.2" y1="702" x2="781" y2="1041.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1081.9" y1="698.1" x2="774.3" y2="1048.9"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1057.8" y1="693.9" x2="767.9" y2="1055.6"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1033.8" y1="689.3" x2="761.7" y2="1061.9"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="1009.9" y1="684.4" x2="755.8" y2="1067.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="986.2" y1="679.2" x2="750.2" y2="1073.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="962.7" y1="673.7" x2="744.7" y2="1078.6"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="939.3" y1="667.9" x2="739.5" y2="1083.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="916.2" y1="661.7" x2="734.5" y2="1087.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="893.2" y1="655.3" x2="729.6" y2="1091.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="870.5" y1="648.6" x2="725" y2="1095.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="847.9" y1="641.6" x2="720.4" y2="1098.6"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="825.6" y1="634.3" x2="716" y2="1101.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="803.5" y1="626.8" x2="711.7" y2="1103.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="781.7" y1="619" x2="707.5" y2="1105.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="760.1" y1="611" x2="703.4" y2="1107.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="738.7" y1="602.7" x2="699.4" y2="1108.6"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="717.6" y1="594.1" x2="695.3" y2="1109.4"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="702.8" y1="581.7" x2="691.4" y2="1109.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="685.6" y1="565.8" x2="687.4" y2="1109.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="673.2" y1="554.3" x2="683.4" y2="1109.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="657.1" y1="566.4" x2="679.4" y2="1108.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="641.9" y1="579.4" x2="675.4" y2="1107"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="621.2" y1="588" x2="671.3" y2="1105.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="600.3" y1="596.3" x2="667.1" y2="1103.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="579.1" y1="604.5" x2="662.9" y2="1100.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="557.7" y1="612.4" x2="658.5" y2="1097.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="536" y1="620.1" x2="654" y2="1094.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="514.1" y1="627.5" x2="649.4" y2="1090.9"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="492" y1="634.6" x2="644.6" y2="1086.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="469.6" y1="641.5" x2="639.7" y2="1082.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="447" y1="648" x2="634.5" y2="1077.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="424.2" y1="654.4" x2="629.2" y2="1072.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="401.3" y1="660.4" x2="623.6" y2="1066.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="378.1" y1="666.1" x2="617.8" y2="1060.7"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="354.8" y1="671.5" x2="611.8" y2="1054.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="331.3" y1="676.6" x2="605.4" y2="1047.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="307" y1="680" x2="598.8" y2="1040.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="283.8" y1="685.9" x2="592" y2="1033.5"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="259.8" y1="690.1" x2="584.7" y2="1025.9"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="235.8" y1="693.9" x2="577.2" y2="1017.9"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="19.1" y1="526.1" x2="561.1" y2="1001"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="19.8" y1="555.3" x2="552.6" y2="992.2"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="20.3" y1="581.4" x2="543.6" y2="983"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="20.8" y1="604.6" x2="534.3" y2="973.6"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="21.3" y1="625.4" x2="524.5" y2="963.9"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="21.7" y1="644" x2="514.4" y2="954"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="22" y1="660.4" x2="503.8" y2="943.8"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="22.4" y1="675" x2="492.8" y2="933.3"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="21.3" y1="674.4" x2="22.4" y2="675"/>
  <motion.line  pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" x1="22.6" y1="687.8" x2="481.4" y2="922.7"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M22.9,699.1c225.2,107.3,446.6,212.8,446.6,212.8"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.1,708.8c222.2,98.3,434,192,434,192"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.3,717c218.5,89.5,421,172.5,421,172.5"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.4,724c214.2,81,407.6,154.1,407.6,154.1"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.5,729.6c209.4,72.8,393.7,136.9,393.7,136.9"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.6,734.1c204,65,379.3,120.8,379.3,120.8"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.7,737.3c198.1,57.4,364.4,105.6,364.4,105.6"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.7,739.5c191.7,50.2,349.1,91.4,349.1,91.4"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M24,740.6c184.8,43.4,333.1,78.2,333.1,78.2"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.8,740.6c.1,0,.2,0,.2,.1"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.8,740.6c177.5,36.9,317,66,317,66"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.7,739.6c169.6,30.9,300.1,54.7,300.1,54.7"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23,739.5c.2,0,.5,.1,.7,.1"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.7,737.6c161.3,25.2,282.8,44.3,282.8,44.3"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.6,734.6c152.5,20,265,34.8,265,34.8"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.6,730.6c143.2,15.3,246.7,26.3,246.7,26.3"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.4,725.6c133.4,10.9,227.8,18.7,227.8,18.7"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.3,719.7c123.1,7.1,208.4,12,208.4,12"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23.2,712.8c112.3,3.8,188.5,6.3,188.5,6.3"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M23,704.9c101.1,1,168.1,1.6,168.1,1.6"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M22.8,696c89.3-1.3,147.2-2.1,147.2-2.1"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M22.6,686.1c77-2.9,125.7-4.8,125.7-4.8"/>
  <motion.path pathLength="1"
        style={{ pathLength: scrollYProgress }} className="fondow" className="fondow" d="M22.4,675.2c64.2-4,103.7-6.4,103.7-6.4"/>
    </motion.svg>
  </div>
)};
export default Fondo5;